import { createSlice } from '@reduxjs/toolkit';
import { initialState, commonReducers } from './fileVersionHistory.slice';

const vehicleTechSpecsVersionHistorySlice = createSlice({
  name: 'vehicleTechSpecsVersionHistory',
  initialState,
  reducers: { ...commonReducers },
});

export default vehicleTechSpecsVersionHistorySlice.reducer;
export const {
  setOpenFileVersionHistory,
  setOpenDeleteVersionConfirmationModal,
  addToFileVersions,
  getNextVersions,
  deletedLastVersion,
} = vehicleTechSpecsVersionHistorySlice.actions;
